export const defaultPageSize = 50;

export const sortOrderList = [
  {
    text: 'Newest to Oldest',
    value: '-1'
  },
  {
    text: 'Oldest to Newest',
    value: '1'
  }
];

export const applicationStatus = {
  APPROVE: 'Approved',
  REJECT: 'Rejected',
  CURRENT: 'Current',
  PENDING: 'Pending'
};
export const applicationTypes = {
  APPLICATION: 'application',
  CALL: 'call'
};

export const applicationStatusList = Object.values(applicationStatus).map(
  (key) => ({
    text: key,
    value: key
  })
);
export const applicationtypeList = Object.values(applicationTypes).map(
  (key) => ({
    text: key,
    value: key
  })
);

export const restrictedFieldNames = ['_id', 'status'];
export const restrictedEditFieldNames = [
  '_id',
  'status',
  'fullName',
  'email',
  'courseCode',
  'createdAt',
  'updatedAt',
  'statusUpdatedAt',
  'approvedBy',
  'rejectedBy',
  'reviewerNotes'
];
